import { render, staticRenderFns } from "./FooterInfo.vue?vue&type=template&id=24da67b7&scoped=true"
import script from "./FooterInfo.vue?vue&type=script&lang=js"
export * from "./FooterInfo.vue?vue&type=script&lang=js"
import style0 from "./FooterInfo.vue?vue&type=style&index=0&id=24da67b7&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "24da67b7",
  null
  
)

export default component.exports